import { useCallback, useEffect, useRef, useState } from 'react';
export function useCommandPaletteState({ inputRef, isOrgAdmin }) {
    const [isOpen, setIsOpen] = useState(false);
    const [mode, setMode] = useState('commands');
    const [search, setSearch] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const closeTimerRef = useRef(null);
    const resetPalette = useCallback(() => {
        setMode('commands');
        setSearch('');
        setActiveIndex(0);
    }, []);
    const focusInput = useCallback(() => {
        requestAnimationFrame(() => inputRef.current?.focus());
    }, [inputRef]);
    const open = useCallback(() => {
        if (!isOrgAdmin)
            return;
        setIsOpen(true);
        focusInput();
    }, [focusInput, isOrgAdmin]);
    const close = useCallback(() => {
        setIsOpen(false);
        if (closeTimerRef.current)
            clearTimeout(closeTimerRef.current);
        closeTimerRef.current = setTimeout(() => {
            resetPalette();
        }, 150);
    }, [resetPalette]);
    const toggle = useCallback(() => {
        if (isOpen) {
            close();
            return;
        }
        open();
    }, [close, isOpen, open]);
    const handleModeChange = useCallback((nextMode) => {
        setMode(nextMode);
        setSearch('');
        setActiveIndex(0);
        focusInput();
    }, [focusInput]);
    const updateSearch = useCallback((value) => {
        setSearch(value);
        setActiveIndex(0);
    }, []);
    useEffect(() => {
        return () => {
            if (closeTimerRef.current)
                clearTimeout(closeTimerRef.current);
        };
    }, []);
    return {
        activeIndex,
        close,
        handleModeChange,
        isOpen,
        mode,
        open,
        search,
        setActiveIndex,
        toggle,
        updateSearch
    };
}
